import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const ParentContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    border: none;
`

export const Filler = styled.div`
    flex: 1;
`

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`

export const ItemsSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 12px 8px;
`

// export const ItemsContainer = styled.div`
//     flex: 1;
//     padding: 12px;
//     background-color: ${Colors.WHITE_SHADE_1};
//     overflow: auto !important;
// `

// export const ContainerTest = styled.div`
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
//     align-items: flex-start !important;
//     width: 100%;
// `

// export const ItemsCategoriesContainer = styled.div`
//     height: 70px;
//     background-color: ${Colors.WHITE_SHADE_1};
//     display: flex; 
//     flex-direction: row;
//     gap: 8px;
//     padding: 10px 8px 10px 8px;
//     overflow-x: auto;
//     overflow-y: hidden;
//     white-space: nowrap;
//     border-top: 1px solid gray;
// `

export const TicketSection = styled(FlexDiv)`
    width: 100%;
    background-color: #F5F5F8;
    display: flex;
    height: 100vh;
    border-left: 1px solid #DEDEE1;
`

// export const TicketHeader = styled(HorizontalFlexDiv)`
//     width: 100%;
//     height: 50px;
//     background-color: #fff;
//     elevation: 4px;
//     color: #000;
//     justify-content: space-between;
//     align-items: center;
//     padding: 8px;
//     box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
//     z-index: 100;
// `

// export const SelectWrapper = styled.div`
//     background-color: white;
// `

// export const TypeSelect = styled(Select)`
//     width: 100%;
//     border-bottom: 1px solid rgba(0,0,0,.2);
//     height: 42px;

//     .ant-select-selector{
//         border: none !important;
//         height: 40px !important;
//         background-color: green;
//     }

//     .ant-select-selection-placeholder{
//         margin-top: 6px;
//     }

//     .ant-select-suffix{
//         margin-right: 1px !important;
//     }

//     .ant-select-selection-search-input{
//         height: 42px !important;
//     }

//     .ant-select-selection-item{
//         margin-top: 6px;
//     }
// `

// export const TicketActionsContainer = styled.div`
//     height: 70px;
//     background-color: #fff;
//     display: flex; 
//     flex-direction: row;
//     gap: 8px;
//     padding: 10px 8px 10px 8px;
//     overflow-x: auto;
//     overflow-y: hidden;
//     white-space: nowrap;
//     border-top: 1px solid gray;
//     justify-content: space-between;
// `

// export const ItemsOrderContainer = styled.div`
//     flex: 1;
//     padding-left: 4px;
//     background-color: ${Colors.WHITE};
//     overflow: auto !important;
// `

// export const ExternalContainer = styled.div`
//     width: 100vh;
//     display: flex;
//     flex-direction: column;
// `

// export const ActionButton = styled(Button)`
//     height: 100%;
//     width: 100%;
//     font-size: 16px;
// `

// export const ItemsSectiontHeader = styled(HorizontalFlexDiv)`
//     width: 100%;
//     height: 50px;
//     background-color: #fff;
//     elevation: 4px;
//     color: #000;
//     justify-content: space-between;
//     align-items: center;
//     padding: 8px;
//     box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
//     z-index: 100;
// `

// export const ItemsSectionLeft = styled(HorizontalFlexDiv)`
// `

// export const ItemsSectionRight = styled(HorizontalFlexDiv)`
// `

// export const TotalList = styled(List)`
//     background-color: white;
// `

// export const TotalItem = styled(List.Item.Meta)`
//     margin-top: 4px;
//     margin-left: 4px;
// `

// export const TotalAmountContainer = styled.div`
//     font-weight: bold;
// `

// export const ItemSubcategoryHeader = styled(HorizontalFlexDiv)`
//     width: 100%;
//     font-family: Inter;
//     font-size: 14px;
//     line-height: 1.19;
//     letter-spacing: 1.14px;
//     text-align: left;
//     color: #373f53;
//     margin-top: 12px;
// `
// export const GroupContainer = styled(FlexDiv)`
//     width: 100%;
// `